export type AddressPosition = {
  lat: number;
  lng: number;
};
export const DEFAULT_ADDRESS_POSITION = {
  lat: 62.436206,
  lng: 15.439425,
} as AddressPosition;
